import { useParams } from 'react-router-dom';
import NotFound from '../NotFound';
import DataProjectHeader from '../../components/data/DataProjectHeader';
import SampleChart from '../../components/data/SampleChart';
import { findDataProject } from '../../data/projects';
import { usePageTitle } from '../../hooks/usePageTitle';

export default function SampleDataProject() {
  const { projectSlug } = useParams();
  const project = findDataProject(projectSlug);
  usePageTitle(project?.charts ? project.title : null);

  if (!project?.charts) {
    return <NotFound />;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <DataProjectHeader
        slug={project.slug}
        title={project.title}
        description={project.description}
        hasEntry={project.hasEntry}
      />
      <div className="space-y-6">
        {project.charts.map((chart) => (
          <SampleChart key={chart.title} {...chart} />
        ))}
      </div>
    </div>
  );
}
